import Vue from 'vue'
import Router from 'vue-router'
import regionCN from './region-cn'
import store from '@/store/'

Vue.use(Router)

const scrollBehavior = function (to, from, savedPosition) {
    if (savedPosition) {
        return savedPosition
    } else if (to.meta && to.meta.scrollTop) {
        return { x: 0, y: 0 }
    }
}
const router = new Router({
    mode: 'history',
    routes: [...regionCN],
    base: '/mobile',
    scrollBehavior
})
router.beforeEach((to, from, next) => {
    // 兼容老包装服务的跳转
    if (to.redirectedFrom && to.redirectedFrom.indexOf('packaging_services/index.html') > -1) {
        return router.push({
            path: '/cn/sc/prd/package?noHead=true&noFooter=true'
        })
    }
    const meta = (to.matched.length && to.matched[to.matched.length - 1].meta) || {}
    // 页面标题、关键字、描述设置
    if (meta.metaInfo && meta.metaInfo.title) {
        store.commit('changeMeta', to.meta.metaInfo)
    } else if (meta.title) {
        document.title = to.matched[to.matched.length - 1].meta.title
    }
    next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/router.js